<template>
  <div>
    <div class="flex items-center justify-between pb-6">
      <p class="text-2xl font-medium">
        Trending Products
      </p>
      <div class="hidden md:flex">
        <div
          class="rounded-full bg-smoke-100 w-10 h-10 opacity-50 cursor-pointer flex items-center mr-3"
          @click="slideProduct(-1)"
        >
          <img src="@/assets/icons/chevronLeft.svg" class="mx-auto">
        </div>
        <div
          class="rounded-full bg-smoke-100 w-10 h-10 opacity-50 cursor-pointer flex items-center"
          @click="slideProduct(1)"
        >
          <img src="@/assets/icons/chevronRight.svg" class="mx-auto">
        </div>
      </div>
    </div>
    <div v-if="products.length">
      <ItemsCarousel
        :items="5"
        :margin="10"
        :dots="false"
        ref="carousel"
      >
        <div
          v-for="(product, index) in firstRowProducts"
          :key="`deal-product-${index}`"
          class="p-1"
        >
          <ProductPreview :product="product" />
          <div class="pt-2.5" v-if="secondRowProducts[index]">
            <ProductPreview :product="secondRowProducts[index]" />
          </div>
        </div>
      </ItemsCarousel>
    </div>
    <div v-else class="py-12 text-center">
      <p>{{ loading ? 'Loading...' : 'No product found.' }}</p>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import ItemsCarousel from '@/shared/components/shared/ItemsCarousel'
import ProductPreview from '@/shared/components/product/ProductPreview'

export default {
  name: 'TrendingProductsSection',
  components: { ItemsCarousel, ProductPreview },
  data() {
    return {
      products: [],
      loading: false
    }
  },
  async created() {
    this.products = await this.fetchTrendingProducts()
  },
  computed: {
    firstRowProducts() {
      return this.products.length > (this.isMobile ? 5 : 9)
        ? this.products.slice(0, this.half)
        : this.products.slice(0, 5)
    },
    secondRowProducts() {
      return this.products.length > (this.isMobile ? 5 : 9)
        ? this.products.slice(this.half)
        : this.products.slice(5, 10)
    },
    isMobile() { return window.innerWidth < 600 },
    half() { return Math.ceil(this.products.length / 2) }
  },
  methods: {
    ...mapActions ([
      'fetchTrendingProducts'
    ]),
    slideProduct(val) {
      if (!this.$refs.carousel) return
      const navs = this.$refs.carousel.$el.querySelectorAll('.owl-nav')
      navs.forEach(nav => {
        val === 1 ? nav.lastChild.click() : nav.firstChild.click()
      })
    }
  }
}
</script>
